import React from 'react'
import styled from 'styled-components'

interface ReceiptLinkProps {
  receiptUrl: string | null | undefined
  /** When true, clicking the link does not trigger parent click (e.g. table row). Default false. */
  stopPropagation?: boolean
}

const Link = styled.a`
  color: ${(props) => props.theme.palette.accent.blue900};
  text-decoration-color: ${(props) => props.theme.palette.accent.blue900};

  &:hover {
    color: ${(props) => props.theme.palette.accent.blue800};
    text-decoration-color: ${(props) => props.theme.palette.accent.blue800};
  }

  &:visited {
    color: ${(props) => props.theme.palette.accent.blue900};
    text-decoration-color: ${(props) => props.theme.palette.accent.blue900};
  }
`

const ReceiptLink = React.memo(
  ({ receiptUrl, stopPropagation = false }: ReceiptLinkProps) => {
    if (!receiptUrl) {
      return <>-</>
    }
    return (
      <Link
        href={receiptUrl}
        target='_blank'
        rel='noopener noreferrer'
        onClick={stopPropagation ? (e) => e.stopPropagation() : undefined}
      >
        View receipt
      </Link>
    )
  }
)

if (process.env.NODE_ENV !== 'production') {
  ReceiptLink.displayName = 'ReceiptLink'
}

export default ReceiptLink
